import React, { useState, useEffect } from 'react';

const SupportOffline = ({ children, supportOffline }) => {
  const [isOnline, setisOnline] = useState(true);

  const goOnline = () => {
    fetch('/api/networkchecker', { method: 'GET' })
      .then((resp) => resp.json())
      .then((data) => {
        window.awpIsOnline = data?.status ?? false;
        setisOnline(window.awpIsOnline);
      });
  };

  const goOffline = () => {
    window.awpIsOnline = false;
    setisOnline(false);
  };

  useEffect(() => {
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (isOnline && window.awpIsOnline) {
    return children;
  } else {
    if (supportOffline) {
      return children;
    } else {
      return <></>;
    }
  }
};

export default SupportOffline;
